<template>
  <div
    v-show="showOption"
    class="product-list__item"
  >
    <div class="product__summary-wrapper">
      <div class="product__summary">
        <div class="product__header">
          <h2 class="product__title">
            {{ productOption.name }}
          </h2>
          <div
            v-for="(offerLine, index) in productOption.offerLines"
            :key="index"
            :disabled="disabled"
          >
            <div class="mb-2 mt-2">
              <div class="font-weight-bold">
                <span>{{ offerLine.name }}</span>
                <span
                  v-show="offerLine.pricePerUnit !== offerLine.totalPricePerUnit"
                  class="float-right"
                >
                  Discounted Price:
                </span>
                <span class="float-right">
                  {{ $n(offerLine.totalPricePerUnit, 'currency', languageCode) }}
                </span>
                <span
                  v-show="offerLine.pricePerUnit !== offerLine.totalPricePerUnit"
                  class="float-right"
                >
                  (Full Price: {{ $n(offerLine.pricePerUnit, 'currency', languageCode) }})
                </span>
              </div>
            </div>
          </div>
          <div v-if="!productOption.offerLines">
            <p class="product__price">
              <span v-show="showWhenPricesDiffer">Discounted Price: </span>{{ $n(price, 'currency', languageCode) }}
            </p>
            <span
              v-show="showWhenPricesDiffer"
            >
              (Full Price: {{ $n(originalPrice, 'currency', languageCode) }})
            </span>
          </div>
          <p v-if="productOption.transferInformation"><strong>{{ productOption.transferInformation }}</strong></p>
          <div
            v-html="productOption.description"
          />
          <div class="product__additional">
            <div class="product__additional-extra">
              <button
                v-show="hideWhenOptionSelected"
                class="btn btn-primary mb-2"
                @click="setSelectedProductId"
              >
                Add product
              </button>
              <button
                v-show="showWhenOptionSelected"
                :disabled="disabled"
                class="btn btn-primary mb-2"
                @click="resetSelectedProductId"
              >
                Remove product
              </button>
            </div>
            <div class="product__additional-button">
              <div
                v-show="isMoreVisible"
                class="product__additional-content"
              >
                <div class="row">
                  <a
                    class="button button--ghost product__info-close"
                    @click="isMoreVisible = !isMoreVisible"
                  ><span class="visuallyhidden">Close</span></a>
                  <div
                    class="product__additional-info col-md-6"
                    v-html="productOption.moreInformation"
                  />
                  <div class="col-md-6 product__additional-map">
                    <img :src="productOption.mapImageUrl">
                  </div>
                </div>
              </div>
              <button
                type="button"
                class="btn btn-block"
                data-toggle="modal"
                data-target="#exampleModal"
                @click="toggle"
              >
                {{ isMoreVisible ? 'Less information' : 'More information' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'ProductOption',
    props: {
        productOption: {
            type: Object,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            isMoreVisible: false
        }
    },
    computed: {
        ...mapState({
            selectedProductId: state => state.product.selectedProductId
        }),
        showOption () {
            return this.selectedProductId === null ||
                this.selectedProductId === this.productOption.id
        },
        hideWhenOptionSelected () {
            return this.selectedProductId !== this.productOption.id
        },
        showWhenOptionSelected () {
            return this.selectedProductId === this.productOption.id
        },
        showWhenPricesDiffer () {
            return this.price !== this.originalPrice
        },
        price () {
            if (this.productOption.offerLines !== undefined) {
                return this.productOption.offerLines
                    .reduce((max, o) => o.totalPricePerUnit > max ? o.totalPricePerUnit : max, this.productOption.offerLines[0].totalPricePerUnit)
            }
            return this.productOption.price
        },
        originalPrice () {
            if (this.productOption.offerLines !== undefined) {
                return this.productOption.offerLines
                    .reduce((max, o) => o.pricePerUnit > max ? o.pricePerUnit : max, this.productOption.offerLines[0].pricePerUnit)
            }
            return this.productOption.originalPrice
        },
        remainingSpaces () {
            if (this.productOption.remainingSpacesCount !== undefined) { return this.productOption.remainingSpacesCount }
            return this.productOption.remainingSpaces
        },
        languageCode () {
            var code = this.$store.getters['getLanguageCode']({
                identifier: this.$store.state.airport.selectedAirportId
            })
            if (code !== null) {
                return code
            }
            return 'en-GB'
        }
    },
    methods: {
        toggle () {
            this.isMoreVisible = !this.isMoreVisible
        },
        setSelectedProductId () {
            this.$store.commit('product/setSelectedProductId', this.productOption.id)
        },
        resetSelectedProductId () {
            this.$store.dispatch('resetBookingReserveResponse')
            this.$store.commit('product/resetSelectedProductId')
        }
    }
}
</script>
